import { render, staticRenderFns } from "./AdminMessageList.vue?vue&type=template&id=b35697e8&scoped=true"
import script from "./AdminMessageList.vue?vue&type=script&lang=js"
export * from "./AdminMessageList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/admin_message_center.css?vue&type=style&index=0&id=b35697e8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35697e8",
  null
  
)

export default component.exports